// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import Login from "./pages/Login";
import Upload from "./pages/Upload";
import MusicList from "./pages/MusicList";
import ArtistList from "./pages/ArtistList";
import ArtistCreate from "./pages/ArtistCreate";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route
                  path="/upload"
                  element={
                    <ProtectedRoute>
                      <Upload />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/music"
                  element={
                    <ProtectedRoute>
                      <MusicList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/artist"
                  element={
                    <ProtectedRoute>
                      <ArtistList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/artist/create"
                  element={
                    <ProtectedRoute>
                      <ArtistCreate />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};
export default App;
